import { Group, MultiSelect, Stack } from '@mantine/core';
import { inkLight, secondaryBase } from '../../styles/design-tokens';
import { Divider } from '../../ui-library/divider/divider';
import { Icon } from '../../ui-library/icon/icon';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { Text } from '../../ui-library/typography/typography';
import { toComboboxData } from './filter-panel.helpers';
import type { FilterGroup } from './filter-panel.type';

type Props<T extends FilterGroup> = {
  group: T;
  handleMultiSelectChange: (group: T, values: string[]) => void;
  hasDivider?: boolean;
};

export const FilterPanelGroupMultiSelect = <T extends FilterGroup>({
  group,
  handleMultiSelectChange,
  hasDivider = true,
}: Props<T>) => {
  return (
    <Stack key={group.name} gap={16}>
      <Group justify="space-between">
        <Group gap="xs">
          {group.icon && <Icon name={group.icon} size={16} color={inkLight} />}
          <Text weight="medium" size="small">
            {group.name}
          </Text>
          {group.tooltip && (
            <Tooltip label={group.tooltip} variant="black" multiline maw={300}>
              <Icon name="info" size={16} color={secondaryBase} />
            </Tooltip>
          )}
        </Group>
      </Group>

      <MultiSelect
        value={group.selectedValues}
        data={toComboboxData(group.options)}
        onChange={(values) => handleMultiSelectChange(group, values)}
        placeholder={`Select ${group.name}`}
        clearable={group.optional}
        radius="xl"
        searchable={group.searchable}
        maxDropdownHeight={400}
        comboboxProps={{ position: 'bottom' }}
        disabled={group.disabled}
        renderOption={group.renderOption}
      />
      {hasDivider && <Divider style={{ marginTop: '8px' }} />}
    </Stack>
  );
};
